
import { docField } from "services/InputFieldsDocumentos"
import { LineWithText } from "components/FormGerarGuia"

// constant imports
import { TIPO, SUBTIPO } from "constants/tiposDoc"

const enderecoBase = () =>
{
    return (
        <>
            {docField.cep()}
            {docField.logradouro()}
            {docField.numPorta()}
            {docField.loteamento()}
            {docField.numQuadra()}
            {docField.numLote()}
            {docField.bairro()}
            {docField.complemento()}
        </>
    )
}

export const section =
{
    AreaConstruida: () =>
    {
        return (
            <div>
                <LineWithText text={"Área construída"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.areaConstruida()}
                </div>
            </div>
        )
    },
    AreaRemanescenteDesm: () =>
    {
        return (
            <div>
                <LineWithText text={"Áreas remanescentes"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.areaRemanescente()}
                </div>
            </div>
        )
    },
    AreaTotalDemarcada: () =>
    {
        return (
            <div>
                <LineWithText text={"Área total demarcada"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.areaTotalDemarcada()}
                </div>
            </div>
        )
    },
    AreasLotes: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Áreas dos lotes"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areasLotes(qtd)}
                    </div>
                </div>
        )
    },
    AreasVerdes: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Áreas verdes"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areasVerdes(qtd)}
                    </div>
                </div>
        )
    },
    AreasSistViario: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Áreas do sistema viário"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areasSistViario(qtd)}
                    </div>
                </div>
        )
    },
    Certifico: (tipoDoc, subTipoDoc) => 
    {
        return (
            <div>
                <LineWithText text={"Certifico"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.certifico(tipoDoc, subTipoDoc)}
                </div>
            </div>
        )
    },
    Conclusao: () =>
    {
        return (
                <div>
                    <LineWithText text={"Conclusao"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.conclusao()}
                    </div>
                </div>
        )
    },
    Contratada: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações da contratada"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.contratada()}
                        {docField.cpfCnpjContratada()}
                    </div>
                </div>
        )
    },
    Contratante: () =>
    {
        return (
                <div>
                    <LineWithText text={"Contratante"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.contratante()}
                        {docField.cpfCnpjContratante()}
                        {docField.enderecoContratante()}
                    </div>
                </div>
        )
    },
    DadosCartoriais: () =>
    {
        return (
                <div>
                    <LineWithText text={"Dados cartoriais"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.matriculaRegistro()}
                        {docField.cartorioZonaImob()}
                        {docField.superintUniaoSE()}
                    </div>
                </div>
        )
    },
    DadosImovel: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.inscCadastral()}
                        {enderecoBase()}
                    </div>
                </div>
        )
    },
    DadosImovelComNomeEmpreendimento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.nomeEmpreendimento()}
                        {enderecoBase()}
                    </div>
                </div>
        )
    },
    DadosImovelComNomeEmpreendimentoEInscCadastral: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.nomeEmpreendimento()}
                        {docField.inscCadastral()}
                        {enderecoBase()}
                    </div>
                </div>
        )
    },
    DadosImovelComAtividadeENomeEmpreendimento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.nomeEmpreendimento()}
                        {docField.inscCadastral()}
                        {docField.atividade()}
                        {enderecoBase()}
                    </div>
                </div>
        )
    },
    DadosImovelLoteamento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.nomeEmpreendimento()}
                        {docField.inscCadastral()}
                        {docField.cep()}
                        {docField.logradouro()}
                        {docField.numPorta()}
                        {docField.bairro()}
                        {docField.complemento()}
                    </div>
                </div>
        )
    },
    DadosImovelComNomeEmpreendimentoDirDrenagem: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {enderecoBase()}
                    </div>
                </div>
        )
    },
    DadosImovelHabitese: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações do imóvel"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {enderecoBase()}
                        {docField.finalidade()}
                        {docField.inscCadastral()}
                        {docField.areaTotal()}
                    </div>
                </div>
        )
    },
    DadosObra: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações da obra"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.cepObra()}
                        {docField.logradouroObra()}
                        {docField.numPortaObra()}
                        {docField.loteamentoObra()}
                        {docField.numQuadraObra()}
                        {docField.numLoteObra()}
                        {docField.bairroObra()}
                        {docField.complementoObra()}
                    </div>
                </div>
        )
    },
    DadosServicos: () =>
    {
        return (
                <div>
                    <LineWithText text={"Informações dos serviços"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.tipoDeObra()}
                        {docField.valorDosServicos()}
                        {docField.prazoExecServicos()}
                    </div>
                </div>
        )
    },
    DescricaoConfrontacoesAreaDemarcada: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Descrição e confrontações da(s) área(s) demarcada(s) conforme planta aprovada"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.loteDescricaoAreaDemarcada(qtd)}
                    </div>
                </div>
        )
    },
    DescricaoConfrontacoesAreaDesmembrada: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Descrição e confrontações da(s) área(s) desmembrada(s) conforme planta aprovada"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.loteDescricaoAreaDesmembrada(qtd)}
                    </div>
                </div>
        )
    },
    DescricaoConfrontacoesAreaRemembrada: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Descrição e confrontações da(s) área(s) remembrada(s) conforme planta aprovada"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.loteDescricaoAreaRemembrada(qtd)}
                    </div>
                </div>
        )
    },
    Empreendimento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areaTerreno()}
                        {docField.areaAverbada()}
                        {docField.areaReforma()}
                        {docField.areaDemolir()}
                        {docField.areaAcrescida()}
                        {docField.areaConstruida()}
                        {docField.areaComputavel()}
                        {docField.areaPermeavel()}
                        {docField.numPav()}
                        {docField.gabaritoAltura()}
                        {docField.numElevadores()}
                        {docField.numeroPlataformas()}
                    </div>
                </div>
        )
    },
    EmpreendimentoAnuencia: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex">
                        {docField.areaTerreno()}
                        {docField.areaAverbada()}
                        {docField.areaReforma()}
                        {docField.areaRegularizar()}
                        {docField.areaDemolir()}
                        {docField.areaAcrescida()}
                    </div>
                    <div className="d-flex">
                        {docField.areaConstruida()}
                        {docField.areaComputavel()}
                        {docField.areaPermeavel()}
                        {docField.gabaritoAltura()}
                        {docField.numPav()}
                        {docField.numElevadores()}
                        {docField.numeroPlataformas()}
                    </div>
                </div>
        )
    },
    EmpreendimentoComBlocos: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areaTerreno()}
                        {docField.areaAverbada()}
                        {docField.areaReforma()}
                        {docField.areaDemolir()}
                        {docField.areaAcrescida()}
                        {docField.areaConstruida()}
                        {docField.areaComputavel()}
                        {docField.areaPermeavel()}
                        {docField.blocos()}
                        {docField.numPav()}
                        {docField.gabaritoAltura()}
                        {docField.numElevadores()}
                        {docField.numeroPlataformas()}
                    </div>
                </div>
        )
    },
    EmpreendimentoComNumUnid: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areaTerreno()}
                        {docField.areaAverbada()}
                        {docField.areaReforma()}
                        {docField.areaDemolir()}
                        {docField.areaAcrescida()}
                        {docField.areaConstruida()}
                        {docField.areaComputavel()}
                        {docField.areaPermeavel()}
                        {docField.blocos()}
                        {docField.unidades()}
                        {docField.numPav()}
                        {docField.gabaritoAltura()}
                        {docField.numElevadores()}
                        {docField.numeroPlataformas()}
                    </div>
                </div>
        )
    },
    EmpreendimentoLoteamento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areaTerreno()}
                        {docField.areaVia()}
                        {docField.areaLagoa()}
                        {docField.areaLiquida()}
                        {docField.qtdLotes()}
                    </div>
                </div>
        )
    },
    EmpreendimentoMultiresAnuencia: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex">
                        {docField.areaTerreno()}
                        {docField.areaAverbada()}
                        {docField.areaReforma()}
                        {docField.areaRegularizar()}
                        {docField.areaDemolir()}
                        {docField.areaAcrescida()}
                    </div>
                    <div className="d-flex">
                        {docField.areaConstruida()}
                        {docField.areaComputavel()}
                        {docField.areaPermeavel()}
                        {docField.gabaritoAltura()}
                        {docField.numPav()}
                        {docField.numElevadores()}
                    </div>
                    <div className="d-flex">
                        {docField.numeroPlataformas()}
                        {docField.blocos()}
                        {docField.unidades()}
                    </div>
                </div>
        )
    },
    EmpreendimentoRegulLoteamento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.areaTerreno()}
                        {docField.areaVia()}
                        {docField.areaLagoa()}
                        {docField.areaVerde()}
                        {docField.sistViario()}
                        {docField.areaLotes()}
                        {docField.areaLiquida()}
                        {docField.qtdLotes()}
                    </div>
                </div>
        )
    },
    EspecificacoesAut: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações da autorização"} align="Left" />
                    {docField.registrosMatriculas(qtd)}
                </div>
        )
    },
    EspecificacoesAutERB: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações da autorização"} align="Left" />
                    {docField.tipoServico()}
                    {docField.areaTotal()}
                </div>
        )
    },
    EspecificacoesCertidaoLoteamento: () => // apesar do nome, vai para o geradoc como Especificações da Autorização
    {
        return (
                <div>
                    <LineWithText text={"Especificações da certidão"} align="Left" />
                    {docField.tipoServico()}
                </div>
        )
    },
    EspecificacoesEmpreendimento: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    {docField.centroHistorico()}
                    {docField.interesseCultural()}
                    {docField.entornoPatrimonio()}
                    {docField.obraPublica()}
                    {docField.numElevadores()}
                </div>
        )
    },
    EspecificacoesEmpreendimentoCertUsoOcupSolo: () =>
    {
        return (
                <div>
                    <LineWithText text={"Especificações do empreendimento"} align="Left" />
                    <div className="d-flex">
                        {docField.infraestruturaLocal()}
                        {docField.vizinhanca()}
                        {docField.areaTerreno()}
                        {docField.areaConstruida()}
                        {docField.unidades()}
                        {docField.numPav()}
                        {docField.gabaritoAltura()}
                    </div>
                </div>
        )
    },
    LocalIdentObra: () =>
    {
        return (
                <div>
                    <LineWithText text={"Localização e identificação da obra"} align="Left" />
                    <div>
                        {docField.interferenciaSistViario()}
                        {docField.interferenciaMacrodrenagem()}
                    </div>
                    <div className="d-flex">
                        {docField.bairrosObraInfra()}
                    </div>
                    <div className="d-flex">
                        {docField.dadosObraInfra()}
                    </div>
                </div>
        )
    },
    MemorialDescritivo: () =>
    {
        return (
            <div>
                <LineWithText text={"MemorialDescritivo"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.memorialDescritivo()}
                </div>
            </div>
        )
    },
    Notas: (tipoDoc) =>
    {
        return (
            <div>
                <LineWithText text={"Notas"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.notas(tipoDoc)}
                </div>
            </div>
        )
    },
    NumPorta: () =>
    {
        return (
            <div>
                <LineWithText text={"Número de porta"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.numPorta()}
                </div>
            </div>
        )
    },
    Obs: (qtdObs, tipoDoc, subTipoDoc) =>
    {
        return (
            <div>
                <LineWithText text={"Observações"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.obs(qtdObs, tipoDoc, subTipoDoc)}
                </div>
            </div>
        )
    },
    Pavimentos: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Pavimentos"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.pavimentos(qtd)}
                    </div>
                </div>
        )
    },
    Processo: () =>
    {
        return (
                <div>
                    <LineWithText text={"Processo"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        <div>
                            {docField.autoNumerar()}
                            {docField.numDoc()}
                        </div>
                        {docField.numProc()}
                        {docField.anoProc()}
                    </div>
                </div>
        )
    },
    Proprietario: () =>
    {
        return (
                <div>
                    <LineWithText text={"Proprietário"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.nomeProprietario()}
                        {docField.cpfCnpjProprietario()}
                    </div>
                </div>
        )
    },
    Requerente: () =>
    {
        return (
                <div>
                    <LineWithText text={"Requerente"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.nomeRequerente()}
                        {docField.cpfCnpjRequerente()}
                    </div>
                </div>
        )
    },
    RespTec: (qtd) =>
    {
        return (
                <div>
                    <LineWithText text={"Responsáveis técnicos"} align="Left" />
                    <div className="d-flex flex-wrap align-items-end">
                        {docField.respTec(qtd)}
                    </div>
                </div>
        )
    },
    UnidHab: (qtd) =>
    {
        return (
            <div>
                <LineWithText text={"Unidades habitacionais"} align="Left" />
                <div className="d-flex flex-wrap align-items-end">
                    {docField.unidadesHabitacionais(qtd)}
                </div>
            </div>
        )
    },        
    RegistrosProcessosImovel: () =>
    {
        return (
                <div>
                    <LineWithText text={"Registro de processos do imóvel"} align="Left" />
                    <div className="d-flex">
                        {docField.registroAutRepGerais()}
                        {docField.registroProcesso()}
                    </div>
                </div>
        )
    },
    ServicosASeremRealizados: () =>
    {
        return (
                <div>
                    <LineWithText text={"Serviços a serem realizados"} align="Left" />
                    <div className="d-flex">
                        {docField.servicosASeremRealizados()}
                    </div>
                </div>
        )
    },
    SituacaoInLoco: () =>
    {
        return (
                <div>
                    <LineWithText text={"Situação in loco"} align="Left" />
                    <div className="d-flex">
                        {docField.situacaoInLoco()}
                    </div>
                </div>
        )
    },
    UsoOcupSolo: () =>
    {
        return (
                <div>
                    <LineWithText text={"Uso e ocupação do solo"} align="Left" />
                    <div className="d-flex">
                        <div className="d-flex align-items between">
                            {docField.servico()}
                            {docField.macrozoneamento()}
                            {docField.adeAia()}
                        </div>
                        <div className="d-flex align-items-around">
                            {docField.zoneamentoAeroporto()}
                            {docField.zonaProtecao()}
                            {docField.zonaRuido()}
                        </div>
                    </div>
                </div>
        )
    },
    UsoOcupSoloComUsosIncomodos: () =>
    {
        return (
                <div>
                    <LineWithText text={"Uso e ocupação do solo"} align="Left" />
                    <div className="d-flex">
                        <div className="d-flex align-items between">
                            {docField.servico()}
                            {docField.macrozoneamento()}
                            {docField.adeAia()}
                        </div>
                        <div className="d-flex align-items-around">
                            {docField.zoneamentoAeroporto()}
                            {docField.zonaProtecao()}
                            {docField.zonaRuido()}
                        </div>
                    </div>
                    <div>
                        {docField.usosIncomodos()}
                    </div>
                </div>
        )
    },
    UsoOcupSoloAut: () =>
    {
        return (
                <div>
                    <LineWithText text={"Uso e ocupação do solo"} align="Left" />
                    <div className="d-flex">
                        <div className="d-flex align-items between">
                            {docField.macrozoneamento()}
                            {docField.adeAia()}
                            {docField.zoneamentoAeroporto()}
                            {docField.zonaProtecao()}
                        </div>
                    </div>
                </div>
        )
    },
    UsoOcupSoloSimples: () =>
    {
        return (
                <div>
                    <LineWithText text={"Uso e ocupação do solo"} align="Left" />
                    <div className="d-flex">
                        {docField.macrozoneamento()}
                        {docField.adeAia()}
                    </div>
                </div>
        )
    },
    UsoOcupSoloCertUsoOcupSolo: () =>
    {
        return (
                <div>
                    <LineWithText text={"Uso e ocupação do solo"} align="Left" />
                    <div className="d-flex">
                        {docField.macrozoneamento()}
                        {docField.adeAia()}
                        {docField.zoneamentoAeroporto()}
                        {docField.zonaProtecao()}
                        {docField.zonaRuido()}
                    </div>
                    <div className="d-flex">
                        {docField.classificacaoUso()}
                        {docField.atividade()}
                        {docField.usosIncomodos()}
                        {docField.classificacaoViaria()}
                        {docField.paisagemNotavel()}
                    </div>
                    <div className="d-flex">
                        <div>
                            {docField.equipamentosImpacto()}
                            {docField.areaSubJudice()}
                            {docField.imovelConstruido()}
                        </div>
                        <div>
                            {docField.areaNonEdificantiSistViario()}
                            {docField.areaNonEdificantiIntPublico()}
                            {docField.patrimonioCultural()}
                        </div>
                    </div>
                </div>
        )
    },
    Vagas: () =>
    {
        return (
                <div>
                    <LineWithText text={"Vagas de estacionamento"} align="Left" />
                    <div className="d-flex">
                        {docField.vagasVeiculo()}
                        {docField.vagasMoto()}
                        {docField.vagasBicicleta()}
                        {docField.descricaoVagas()}
                    </div>
                </div>
        )
    },
    TipoUso: () =>
    {
        return (
                <div>
                    <LineWithText text={"Tipo de uso"} align="Left" />
                    <div className="d-flex">
                        {docField.tipoUso()}
                    </div>
                </div>
        )
    }
}

export function DocForm({ tipoDoc, subTipoDoc, amountGroupFields })
{

    switch (tipoDoc)
    {
        case TIPO.Alvara:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovel()}
                            {section.UsoOcupSolo()}
                            {section.Empreendimento()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                        </>
                    )
                
                case SUBTIPO.MultiresidencialAte4Pav:    
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                            {section.UsoOcupSolo()}
                            {section.Empreendimento()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.UnidHab(amountGroupFields.unidadesHabitacionais)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                
                case SUBTIPO.MultiresidencialAcima4Pav:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoComBlocos()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.UnidHab(amountGroupFields.unidadesHabitacionais)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                case SUBTIPO.NaoResidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComAtividadeENomeEmpreendimento()}
                            {section.UsoOcupSoloComUsosIncomodos()}
                            {section.EmpreendimentoComNumUnid()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                case SUBTIPO.Loteamento:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelLoteamento()}
                            {section.UsoOcupSoloSimples()}
                            {section.EmpreendimentoLoteamento()}
                            {section.AreasLotes(amountGroupFields.areasLotes)}
                            {section.AreasVerdes(amountGroupFields.areasVerdes)}
                            {section.AreasSistViario(amountGroupFields.areasSistViario)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                    
                default: return
            }

        case TIPO.Anuencia:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovel()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoAnuencia()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )

                case SUBTIPO.MultiresidencialAte4Pav:
                case SUBTIPO.MultiresidencialAcima4Pav:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoMultiresAnuencia()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.UnidHab(amountGroupFields.unidadesHabitacionais)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )

                case SUBTIPO.NaoResidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComAtividadeENomeEmpreendimento()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoMultiresAnuencia()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )

                case SUBTIPO.Loteamento:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelLoteamento()}
                            {section.UsoOcupSoloSimples()}
                            {section.EmpreendimentoLoteamento()}
                            {section.AreasLotes(amountGroupFields.areasLotes)}
                            {section.AreasVerdes(amountGroupFields.areasVerdes)}
                            {section.AreasSistViario(amountGroupFields.areasSistViario)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                        
                default: return
            }

        case TIPO.DirDrenagem:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.Requerente()}
                    {section.DadosImovelComNomeEmpreendimentoDirDrenagem()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>
            )
            
        case TIPO.AutDemol:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.EspecificacoesAut(amountGroupFields.registrosMatriculas)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )
        
        case TIPO.AutERB:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloAut(amountGroupFields.registrosMatriculas)}
                    {section.EspecificacoesAutERB()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )
            
        case TIPO.AutObrasInfra:
            return (
                <>
                    {section.Processo()}
                    {section.Contratante()}
                    {section.Contratada()}
                    {section.DadosObra()}
                    {section.DadosServicos()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )
        
        case TIPO.AutRepGerais:
            return (
                <>
                    {section.Processo()}
                    {section.TipoUso()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )
        
        case TIPO.AutRepGeraisAcess:
            return (
                <>
                    {section.Processo()}
                    {section.TipoUso()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.EspecificacoesEmpreendimento()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.CertDemol:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.Certifico(tipoDoc, subTipoDoc)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )

        case TIPO.CertRegul:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.EmpreendimentoRegulLoteamento()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.EspecificacoesCertidaoLoteamento()}
                    {section.Certifico(tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.CertRegulInfra:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.Contratada()}
                    {section.DadosObra()}
                    {section.DadosServicos()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.CertLaudoVist:
            return (
                <>
                    {section.Processo()}
                    {section.TipoUso()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.CertUsoOcupSolo:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloCertUsoOcupSolo()}
                    {section.EspecificacoesEmpreendimentoCertUsoOcupSolo()}
                    {section.MemorialDescritivo()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.Conclusao()}
                </>  
            )

        case TIPO.CertUsoOcupSoloDir:
            return (
                <>
                    {section.Processo()}
                    {section.Requerente()}
                    {section.LocalIdentObra()}
                    {section.UsoOcupSoloSimples()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )

        case TIPO.Habitese:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelHabitese()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )

        case TIPO.DeclAtendTermoCompr:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclConcObrasInfra:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.Contratada()}
                    {section.DadosObra()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclGLP:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclInstERB:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.DeclNumeroPorta:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.NumPorta()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclRepGerais:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclRepGeraisAcess:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.TermoDemarc:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaDemarcada(amountGroupFields.loteDescricaoAreaDemarcada)}
                    {section.AreaTotalDemarcada()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoDesmLote:
        case TIPO.TermoDesmGleba:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaDesmembrada(amountGroupFields.loteDescricaoAreaDesmembrada)}
                    {section.AreaRemanescenteDesm()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoRem:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaRemembrada(amountGroupFields.loteDescricaoAreaRemembrada)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoRemDesm:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaRemembrada(amountGroupFields.loteDescricaoAreaRemembrada)}
                    {section.DescricaoConfrontacoesAreaDesmembrada(amountGroupFields.loteDescricaoAreaDesmembrada)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoVerObras:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimento()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>
            )

        default: return
    }

}

export function listSectionsDoc(tipoDoc, subTipoDoc, amountGroupFields)
{

    switch (tipoDoc)
    {
        case TIPO.Alvara:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovel()}
                            {section.UsoOcupSolo()}
                            {section.Empreendimento()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                        </>
                    )
                
                case SUBTIPO.MultiresidencialAte4Pav:    
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                            {section.UsoOcupSolo()}
                            {section.Empreendimento()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.UnidHab(amountGroupFields.unidadesHabitacionais)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                
                case SUBTIPO.MultiresidencialAcima4Pav:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoComBlocos()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.UnidHab(amountGroupFields.unidadesHabitacionais)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                case SUBTIPO.NaoResidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComAtividadeENomeEmpreendimento()}
                            {section.UsoOcupSoloComUsosIncomodos()}
                            {section.EmpreendimentoComNumUnid()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                case SUBTIPO.Loteamento:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelLoteamento()}
                            {section.UsoOcupSoloSimples()}
                            {section.EmpreendimentoLoteamento()}
                            {section.AreasLotes(amountGroupFields.areasLotes)}
                            {section.AreasVerdes(amountGroupFields.areasVerdes)}
                            {section.AreasSistViario(amountGroupFields.areasSistViario)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                    
                default: return
            }

        case TIPO.Anuencia:

            switch (subTipoDoc)
            {
                case SUBTIPO.Uniresidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovel()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoAnuencia()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )

                case SUBTIPO.MultiresidencialAte4Pav:
                case SUBTIPO.MultiresidencialAcima4Pav:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoMultiresAnuencia()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.UnidHab(amountGroupFields.unidadesHabitacionais)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )

                case SUBTIPO.NaoResidencial:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelComAtividadeENomeEmpreendimento()}
                            {section.UsoOcupSolo()}
                            {section.EmpreendimentoMultiresAnuencia()}
                            {section.Pavimentos(amountGroupFields.pavimentos)}
                            {section.Vagas()}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )

                case SUBTIPO.Loteamento:
                    return (
                        <>
                            {section.Processo()}
                            {section.Proprietario()}
                            {section.DadosImovelLoteamento()}
                            {section.UsoOcupSoloSimples()}
                            {section.EmpreendimentoLoteamento()}
                            {section.AreasLotes(amountGroupFields.areasLotes)}
                            {section.AreasVerdes(amountGroupFields.areasVerdes)}
                            {section.AreasSistViario(amountGroupFields.areasSistViario)}
                            {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                            {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                        </>
                    )
                        
                default: return
            }

        case TIPO.DirDrenagem:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.Requerente()}
                    {section.DadosImovelComNomeEmpreendimentoDirDrenagem()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>
            )
            
        case TIPO.AutDemol:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.EspecificacoesAut(amountGroupFields.registrosMatriculas)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )
        
        case TIPO.AutERB:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloAut(amountGroupFields.registrosMatriculas)}
                    {section.EspecificacoesAutERB()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )
            
        case TIPO.AutObrasInfra:
            return [
                    section.Processo(),
                    section.Contratante(),
                    section.Contratada(),
                    section.DadosObra(),
                    section.DadosServicos(),
                    section.ServicosASeremRealizados(),
                    section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)
                ]
        
        case TIPO.AutRepGerais:
            return (
                <>
                    {section.Processo()}
                    {section.TipoUso()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )
        
        case TIPO.AutRepGeraisAcess:
            return (
                <>
                    {section.Processo()}
                    {section.TipoUso()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.EspecificacoesEmpreendimento()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.CertRegul:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.AreaConstruida()}
                    {section.Pavimentos(amountGroupFields.pavimentos)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )

        case TIPO.CertRegulInfra:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.Contratada()}
                    {section.DadosObra()}
                    {section.DadosServicos()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.CertLaudoVist:
            return (
                <>
                    {section.Processo()}
                    {section.TipoUso()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.CertUsoOcupSolo:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloCertUsoOcupSolo()}
                    {section.EspecificacoesEmpreendimentoCertUsoOcupSolo()}
                    {section.MemorialDescritivo()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.Conclusao()}
                </>  
            )

        case TIPO.CertUsoOcupSoloDir:
            return (
                <>
                    {section.Processo()}
                    {section.Requerente()}
                    {section.LocalIdentObra()}
                    {section.UsoOcupSoloSimples()}
                    {section.ServicosASeremRealizados()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )

        case TIPO.Habitese:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelHabitese()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                </>  
            )

        case TIPO.DeclAtendTermoCompr:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclConcObrasInfra:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.Contratada()}
                    {section.DadosObra()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclGLP:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclInstERB:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.DeclNumeroPorta:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.NumPorta()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclRepGerais:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.DeclRepGeraisAcess:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.RegistrosProcessosImovel()}
                    {section.Notas(tipoDoc)}
                </>  
            )

        case TIPO.TermoDemarc:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaDemarcada(amountGroupFields.loteDescricaoAreaDemarcada)}
                    {section.AreaTotalDemarcada()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoDesmLote:
        case TIPO.TermoDesmGleba:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaDesmembrada(amountGroupFields.loteDescricaoAreaDesmembrada)}
                    {section.AreaRemanescenteDesm()}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoRem:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaRemembrada(amountGroupFields.loteDescricaoAreaRemembrada)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        case TIPO.TermoRemDesm:
            return (
                <>
                    {section.Processo()}
                    {section.Proprietario()}
                    {section.DadosImovelComNomeEmpreendimentoEInscCadastral()}
                    {section.UsoOcupSoloSimples()}
                    {section.DadosCartoriais()}
                    {section.SituacaoInLoco()}
                    {section.DescricaoConfrontacoesAreaRemembrada(amountGroupFields.loteDescricaoAreaRemembrada)}
                    {section.DescricaoConfrontacoesAreaDesmembrada(amountGroupFields.loteDescricaoAreaDesmembrada)}
                    {section.Obs(amountGroupFields.obs, tipoDoc, subTipoDoc)}
                    {section.RespTec(amountGroupFields.responsaveisTecnicos)}
                </>  
            )

        default: return
    }

}

// export function documentSections(tipoDoc, subTipoDoc)
// {
//     switch (tipoDoc)
//     {
//         case TIPO.Alvara:

//             switch (subTipoDoc)
//             {
//                 case SUBTIPO.Uniresidencial:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovel"), Section("usoOcupSolo"),
//                         Section("empreendimento"), Section("pavimentos"), Section("obs"), Section("respTec")
//                     ]
                    
//                 case SUBTIPO.MultiresidencialAte4Pav:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSolo"),
//                         Section("empreendimento"), Section("pavimentos"), Section("unidHabitacionais"), Section("vagas"), Section("obs"), Section("respTec")
//                     ]
                    
//                 case SUBTIPO.MultiresidencialAcima4Pav:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSolo"),
//                         Section("empreendimentoMultires"), Section("pavimentos"), Section("unidHabitacionais"), Section("vagas"), Section("obs"), Section("respTec")
//                     ]
                
//                 case SUBTIPO.NaoResidencial:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelComAtividadeENomeEmpreendimento"), Section("usoOcupSolo"),
//                         Section("empreendimentoNaoRes"), Section("pavimentos"), Section("vagas"), Section("obs"), Section("respTec")
//                     ]
            
//                 case SUBTIPO.Loteamento:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelLoteamento"), Section("usoOcupSoloSimples"),
//                         Section("empreendimentoNaoResidencial"), Section("obs"), Section("respTec")
//                     ]
                    
//                 default: return
//             }
           
//         case TIPO.Anuencia:

//             switch (subTipoDoc)
//             {
//                 case SUBTIPO.Uniresidencial:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovel"), Section("usoOcupSolo"),
//                         Section("empreendimentoAnuencia"), Section("pavimentos"), Section("obs"), Section("respTec")
//                     ]
                    
//                 case SUBTIPO.MultiresidencialAte4Pav:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSolo"),
//                         Section("empreendimentoMultiresAnuencia"), Section("pavimentos"), Section("unidHabitacionais"), Section("vagas"), Section("obs"), Section("respTec")
//                     ]
                    
//                 case SUBTIPO.MultiresidencialAcima4Pav:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSolo"),
//                         Section("empreendimentoMultiresAnuencia"), Section("pavimentos"), Section("unidHabitacionais"), Section("vagas"), Section("obs"), Section("respTec")
//                     ]
                
//                 case SUBTIPO.NaoResidencial:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelComAtividadeENomeEmpreendimento"), Section("usoOcupSolo"),
//                         Section("empreendimentoMultiresAnuencia"), Section("pavimentos"), Section("vagas"), Section("obs"), Section("respTec")
//                     ]
            
//                 case SUBTIPO.Loteamento:
//                     return [
//                         Section("processo"), Section("proprietario"), Section("imovelLoteamento"), Section("usoOcupSoloSimples"),
//                         Section("empreendimentoNaoResidencial"), Section("obs"), Section("respTec")
//                     ]
                    
//                 default: return
//             }

//         case TIPO.DirDrenagem:

//         return [
//             Section("processo"), Section("proprietario"), Section("requerente"), Section("imovelComNomeEmpreendimentoDirDrenagem"), Section("obs")
//         ]

//         case TIPO.AutDemol:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("especificacoesAutorizacao"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.AutERB:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloAut"),
//             Section("especificacoesAutorizacaoERB"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.AutObrasInfra:

//         return [
//             Section("processo"), Section("contratante"), Section("dadosObra"), Section("dadosServicos"),
//             Section("servicosASeremRealizados"), Section("obs")
//         ]
        
//         case TIPO.AutRepGerais:

//         return [
//             Section("tipoDeUso"), Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"), 
//             Section("servicosASeremRealizados"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.AutRepGeraisAcess:

//         return [
//             Section("tipoDeUso"), Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("especificacoesEmpreendimento"), Section("servicosASeremRealizados"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.CertRegul:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("areaConstruida"), Section("pavimentos"), Section("obs")
//         ]
        
//         case TIPO.CertRegulInfra:

//         return [
//             Section("processo"), Section("proprietario"), Section("dadosObra"), Section("dadosServicos"),
//             Section("servicosASeremRealizados"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.CertLaudoVist:

//         return [
//             Section("tipoDeUso"), Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("registroProcessosImovel"), Section("notas")
//         ]
        
//         case TIPO.CertUsoOcupSolo:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloCertUsoOcupSolo"), Section("especificacoesEmpreendimentoCertUsoOcupSolo"),
//             Section("memorialDescritivo"), Section("obs"), Section("conclusao")
//         ]
        
//         case TIPO.CertUsoOcupSoloDir:

//         return [
//             Section("processo"), Section("requerente"), Section("localIdentObra"), Section("usoOcupSoloSimples"), 
//             Section("servicosASeremRealizados"), Section("obs"), Section("conclusao")
//         ]
        
//         case TIPO.Habitese:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelHabitese"), Section("obs")
//         ]
        
//         case TIPO.DeclAtendTermoCompr:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("registroProcessosImovel"), Section("notas")
//         ]
        
//         case TIPO.DeclConcObrasInfra:

//         return [
//             Section("processo"), Section("proprietario"), Section("dadosObra"), Section("registroProcessosImovel"), Section("notas")
//         ]
        
//         case TIPO.DeclGLP:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("notas")
//         ]
        
//         case TIPO.DeclInstERB:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("registroProcessosImovel"), Section("notas"),
//             Section("respTec")
//         ]
        
//         case TIPO.DeclNumeroPorta:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("numeroPorta"), Section("notas")
//         ]
        
//         case TIPO.DeclRepGerais:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("registroProcessosImovel"), Section("notas"),
//             // Section("dataVistoria")
//         ]
        
//         case TIPO.DeclRepGeraisAcess:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("registroProcessosImovel"), Section("notas"),
//             // Section("dataVistoria")
//         ]
        
//         case TIPO.TermoDemarc:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("dadosCartoriais"), Section("situacaoInLoco"), Section("descricaoConfrontacoesAreaDemarcada"),
//             Section("areaDemarcada"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.TermoDesmGleba:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("dadosCartoriais"), Section("situacaoInLoco"), Section("descricaoConfrontacoesAreaDesmembrada"),
//             Section("areaRemanescenteDesm"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.TermoDesmLote:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("dadosCartoriais"), Section("situacaoInLoco"), Section("descricaoConfrontacoesAreaDesmembrada"),
//             Section("areaRemanescenteDesm"), Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.TermoRem:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("dadosCartoriais"), Section("situacaoInLoco"), Section("descricaoConfrontacoesAreaRemembrada"),
//             Section("obs"), Section("respTec")
//         ]
        
//         case TIPO.TermoRemDesm:

//         return [
//             Section("processo"), Section("proprietario"), Section("imovelComNomeEmpreendimento"), Section("usoOcupSoloSimples"),
//             Section("dadosCartoriais"), Section("situacaoInLoco"), Section("descricaoConfrontacoesAreaRemembrada"),
//             Section("descricaoConfrontacoesAreaDesmembrada"), Section("obs"), Section("respTec")
//         ]

//         default: return
//     }
// }

// function listAllSections()
// {
//     return [
//         "areaConstruida",
//         "areaDemarcada",
//         "areaRemanescenteDesm",
//         "divisaoParcelamentoSolo",
//         "autenticacaoFisc",
//         "conclusao",
//         "contratante",
//         "dadosCartoriais",
//         "dadosObra",
//         "dadosServicos",
//         "descricaoConfrontacoesAreaDemarcada",
//         "descricaoConfrontacoesAreaRemembrada",
//         "descricaoConfrontacoesAreaDesmembrada",
//         "dirDrenagem",
//         "empreendimento",
//         "empreendimentoAnuencia",
//         "empreendimentoMultires",
//         "empreendimentoNaoRes",
//         "empreendimentoMultiresAnuencia",
//         "empreendimentoNaoResidencial",
//         "especificacoesAutorizacao",
//         "especificacoesAutorizacaoERB",
//         "especificacoesEmpreendimento",
//         "especificacoesEmpreendimentoCertUsoOcupSolo",
//         "imovel",
//         "imovelComAtividadeENomeEmpreendimento",
//         "imovelComNomeEmpreendimento",
//         "imovelComNomeEmpreendimentoDirDrenagem",
//         "imovelLoteamento",
//         "imovelHabitese",
//         "localIdentObra",
//         "memorialDescritivo",
//         "notas",
//         "numeroPorta",
//         "pavimentos",
//         "processo",
//         "proprietario",
//         "proprietarioERequerente",
//         "obs",
//         "requerente",
//         "respTec",
//         "respTecProj",
//         "respTecExec",
//         "registroProcessosImovel",
//         "servicosASeremRealizados",
//         "situacaoInLoco",
//         "unidHabitacionais",
//         "usoOcupSolo",
//         "usoOcupSoloAut",
//         "usoOcupSoloSimples",
//         "usoOcupSoloCertUsoOcupSolo",
//         "vagas",
//         "taxaTotal",
//         "tipoDeUso"
//     ]
// }

// function listAllFields()
// {
//     let allSectionsName = listAllSections()
//     let allFieldsName = []

//     allSectionsName.forEach(secName => {
//             const section = Section(secName)
//             const fields = section.inputs
//             fields.forEach(field => allFieldsName.push(field.name))
//         }
//     )

//     console.log(allFieldsName)
// }

// function Section(name)
// {
//     switch (name)
//     {
//         case "areaConstruida": return {"sectionID": name, "sectionName":"Áreas", "inputs": [Field("areaConstruida")]}
//         case "areaDemarcada": return {"sectionID": name, "sectionName":"Áreas", "inputs": [Field("areaTotalDemarcada")]}
//         case "areaRemanescenteDesm": return {"sectionID": name, "sectionName":"Áreas remanescentes", "inputs": [Field("areaRemanescente")]}
//         // case "autenticacao": return {"sectionID": name, "sectionName":"Autenticação", "inputs": [Field("analista")]}
//         case "divisaoParcelamentoSolo": return {"sectionID": name, "sectionName":"Autenticação", "inputs": [Field("divisaoParcelamentoSolo")]}
//         case "autenticacaoFisc": return {"sectionID": name, "sectionName":"Autenticação", "inputs": [Field("divisaoFiscalizacaoPostMun")]}
//         // case "analista": return {"sectionID": name, "sectionName":"Analista", "inputs": [Field("analista")]}

//         case "conclusao": return {"sectionID": name, "sectionName":"Conclusão", "inputs": [Field("conclusao")]}
//         case "contratante": return {"sectionID": name, "sectionName":"Informações do contratante", "inputs": [Field("contratante"), Field("cpfCnpjContratante")]}
        
//         case "dadosCartoriais": return {"sectionID": name, "sectionName":"Dados cartoriais", "inputs": [Field("matriculaRegistro"), Field("cartorioZonaImob"), Field("superintUniaoSE"),]}
//         case "dadosObra": return {"sectionID": name, "sectionName":"Informações da obra", "inputs": [Field("contratada"), Field("cpf_cnpjContratada"), Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
//         // case "dadosObraAutObras": return {"sectionID": name, "sectionName":"Informações da obra", "inputs": [Field("contratada"), Field("cpf_cnpjContratada"), Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
//         case "dadosServicos": return {"sectionID": "dadosServicos", "sectionName":"Dados dos serviços", "inputs": [Field("tipoObra"), Field("valorServicos"), Field("prazoServicos")]}
//         // case "dataVistoria": return {"sectionID": name, "sectionName":"Vistoria", "inputs": [Field("dataVistoria")]}

//         // case "descricaoConfrontacoesInteiroTeor": return {"sectionID": name, "sectionName":"Descrição e confrontações conforme inteiro teor", "inputs": [Field("registrosMatriculas")]}
//         case "descricaoConfrontacoesAreaDemarcada": return {"sectionID": name, "sectionName":"Descrição e confrontações da(s) área(s) demarcada(s) conforme planta aprovada", "inputs": [Field("loteDescricaoAreaDemarcada")]}
//         case "descricaoConfrontacoesAreaRemembrada": return {"sectionID": name, "sectionName":"Descrição e confrontações da(s) área(s) remembrada(s) conforme planta aprovada", "inputs": [Field("loteDescricaoAreaRemembrada")]}
//         case "descricaoConfrontacoesAreaDesmembrada": return {"sectionID": name, "sectionName":"Descrição e confrontações da(s) área(s) desmembrada(s) conforme planta aprovada", "inputs": [Field("loteDescricaoAreaDesmembrada")]}
//         case "dirDrenagem": return {"sectionID": name, "sectionName":"Detalhes das diretrizes", "inputs": [Field("marcosRef"), Field("cotaMinima"), Field("eixoNomeRua"), Field("localBocaDeLoboMaisProxima")]}
        
//         case "empreendimento": return {"sectionID": name, "sectionName":"Especificações do empreendimento", "inputs": [Field("areaTerreno"), Field("areaAverbada"), Field("areaReforma"), Field("areaDemolir"), Field("areaAcrescida"), Field("areaConstruida"), Field("areaComputavel"), Field("areaPermeavel"), Field("numPav"), Field("gabaritoAltura"), Field("numElevadores"), Field("numeroPlataformas")]}
//         case "empreendimentoAnuencia": return {"sectionID": name, "sectionName":"Especificações do empreendimento", "inputs": [Field("areaTerreno"), Field("areaAverbada"), Field("areaReforma"), Field("areaRegularizar"), Field("areaDemolir"), Field("areaAcrescida"), Field("areaConstruida"), Field("areaComputavel"), Field("areaPermeavel"), Field("numPav"), Field("gabaritoAltura"), Field("numElevadores"), Field("numeroPlataformas")]}
//         case "empreendimentoMultires": return {"sectionID": "empreendimento", "sectionName":"Especificações do empreendimento", "inputs": [Field("areaTerreno"), Field("areaAverbada"), Field("areaReforma"), Field("areaDemolir"), Field("areaAcrescida"), Field("areaConstruida"), Field("areaComputavel"), Field("areaPermeavel"), Field("blocos"), Field("numPav"), Field("gabaritoAltura"), Field("numElevadores"), Field("numeroPlataformas")]}
//         case "empreendimentoNaoRes": return {"sectionID": "empreendimento", "sectionName":"Especificações do empreendimento", "inputs": [Field("areaTerreno"), Field("areaAverbada"), Field("areaReforma"), Field("areaDemolir"), Field("areaAcrescida"), Field("areaConstruida"), Field("areaComputavel"), Field("areaPermeavel"), Field("blocos"), Field("unidades"), Field("numPav"), Field("gabaritoAltura"), Field("numElevadores"), Field("numeroPlataformas")]}
//         case "empreendimentoMultiresAnuencia": return {"sectionID": "empreendimento", "sectionName":"Especificações do empreendimento", "inputs": [Field("areaTerreno"), Field("areaAverbada"), Field("areaReforma"), Field("areaRegularizar"), Field("areaDemolir"), Field("areaAcrescida"), Field("areaConstruida"), Field("areaComputavel"), Field("areaPermeavel"), Field("blocos"), Field("unidades"), Field("numPav"), Field("gabaritoAltura"), Field("numElevadores"), Field("numeroPlataformas")]}
//         case "empreendimentoNaoResidencial": return {"sectionID": "empreendimento", "sectionName":"Especificações do empreendimento", "inputs": [Field("areaTerreno"), Field("areaVia"), Field("areaLagoa"), Field("areaLiquida"), Field("areaVerde"), Field("areaLotes"), Field("qtdLotes"), Field("sistViario")]}
        
//         // case "endereco": return {"sectionID": name, "sectionName":"Informações do imóvel", "inputs": [Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
        
//         case "especificacoesAutorizacao": return {"sectionID": name, "sectionName":"Especificações da autorização", "inputs": [Field("registrosMatriculas")]}
//         case "especificacoesAutorizacaoERB": return {"sectionID": "especificacoesAutorizacao", "sectionName":"Especificações da autorização", "inputs": [Field("tipoServico"), Field("areaTotal")]}
//         case "especificacoesEmpreendimento": return {"sectionID": name, "sectionName":"Especificações do empreendimento", "inputs": [Field("centroHistorico"), Field("interesseCultural"), Field("entornoPatrimonio"), Field("obraPublica"), Field("numElevadores")]}
//         case "especificacoesEmpreendimentoCertUsoOcupSolo": return {"sectionID": name, "sectionName":"Especificações do empreendimento", "inputs": [Field("infraestruturaLocal"), Field("vizinhanca"), Field("areaTerreno"), Field("areaConstruida"), Field("unidades"), Field("numPav"), Field("gabaritoAltura") ]}
        
//         case "imovel": return {"sectionID": name, "sectionName":"Informações do imóvel", "inputs": [Field("inscCadastral"), Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
//         case "imovelComAtividadeENomeEmpreendimento": return {"sectionID": "imovel", "sectionName":"Informações do imóvel", "inputs": [Field("nomeEmpreendimento"), Field("inscCadastral"), Field("atividade"), Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
//         case "imovelComNomeEmpreendimento": return {"sectionID": "imovel", "sectionName":"Informações do imóvel", "inputs": [Field("nomeEmpreendimento"), Field("inscCadastral"), Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
//         case "imovelComNomeEmpreendimentoDirDrenagem": return {"sectionID": "imovel", "sectionName":"Informações do imóvel", "inputs": [Field("nomeEmpreendimento"), Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento")]}
//         case "imovelLoteamento": return {"sectionID": "imovel", "sectionName":"Informações do imóvel", "inputs": [Field("nomeEmpreendimento"), Field("inscCadastral"), Field("cep"), Field("endereco"), Field("numPorta"), Field("bairro"), Field("complemento")]}
//         case "imovelHabitese": return {"sectionID": name, "sectionName":"Informações do imóvel", "inputs": [Field("cep"), Field("endereco"), Field("numPorta"), Field("loteamento"), Field("numQuadra"), Field("numLote"), Field("bairro"), Field("complemento"), Field("finalidade"), Field("inscCadastral"), Field("areaTotal")]}
        
//         case "localIdentObra": return {"sectionID": name, "sectionName":"Localização e identificação da obra", "inputs": [Field("bairrosObraInfra"), Field(inputGroupNames.DadosObraInfra), Field("interferenciaSistViario"), Field("interferenciaMacrodrenagem")]}

//         case "memorialDescritivo": return {"sectionID": name, "sectionName":"Características do imóvel (memorial descritivo)", "inputs": [Field("memorialDescritivo")]}
        
//         case "notas": return {"sectionID": name, "sectionName":"Notas", "inputs": [Field("notas")]}
//         case "numeroPorta": return {"sectionID": name, "sectionName":"Notas", "inputs": [Field("numPorta")]}
        
//         case "pavimentos": return {"sectionID": name, "sectionName":"Pavimentos", "inputs": [Field("pavimentos")]}
//         case "processo": return {"sectionID": name, "sectionName":"Informações do processo", "inputs": [Field("numDoc"), Field("numProc"), Field("anoProc")]}
//         case "proprietario": return {"sectionID": name, "sectionName":"Informações do proprietário", "inputs": [Field("nomeProprietario"), Field("cpfCnpjProprietario")]}
//         case "proprietarioERequerente": return {"sectionID": name, "sectionName":"Informações do proprietário", "inputs": [Field("nomeProprietario"), Field("cpfCnpjProprietario"), Field("nomeRequerente")]}
        
//         // case "obsAlvaraLot": return {"sectionID": "observacoes", "sectionName":"Observações", "inputs": [Field("numeroTermoCompromisso"), Field("dataTermoCompromisso"), Field("obsMudancaRuaBairro"), Field("obsDocumentosImovel"), Field("obsExtra")]}
//         case "obs": return {"sectionID": "observacoes", "sectionName":"Observações", "inputs": [Field("obs")]} // Field("obsMudancaRuaBairro"), Field("obsDocumentosImovel"), Field("obsExtra")
//         // case "observacoesAlvaraUnires": return {"sectionID": "observacoes", "sectionName":"Observações", "inputs": [Field("observacoesAlvaraUnires"), Field("obsExtra")]}
//         // case "observacoesTermoDemarc": return {"sectionID": "observacoes", "sectionName":"Observações", "inputs": [Field("observacoesTermoDemarc"), Field("obsExtra")]}
//         // case "obsHabitese": return {"sectionID": "obsHabitese", "sectionName":"Observações complementares", "inputs": [Field("descricaoEdif"), Field("numeroAlvara"), Field("numeroProcessoAlvara"), Field("alteracaoNomeRuaBairro"), Field("obsExtra")]}
//         // case "obsExtra": return {"sectionID": "observacoes", "sectionName": "Observações", "inputs": [Field("obsExtra")]}
        
//         case "requerente": return {"sectionID": name, "sectionName":"Informações do requerente", "inputs": [Field("nomeRequerente"), Field("cpfCnpjRequerente")]}
//         case "respTec": return {"sectionID": name, "sectionName":"Responsáveis técnicos", "inputs": [Field("respTec")]}
//         case "respTecProj": return {"sectionID": name, "sectionName":"Responsável técnico pelo projeto", "inputs": [Field("nomeRespTecProj"), Field("crea_cauRespTecProj")]}
//         case "respTecExec": return {"sectionID": name, "sectionName":"Responsável técnico pela execução", "inputs": [Field("nomeRespTecExec"), Field("crea_cauRespTecExec")]}
//         //case "respTecs": return {"sectionID": name, "sectionName":"Responsáveis técnicos", "inputs": [Field("respTec")]}
//         case "registroProcessosImovel": return {"sectionID": name, "sectionName":"Registro de processos do imóvel", "inputs": [Field("registroAutRepGerais"), Field("registroProcesso")]}
        
//         case "servicosASeremRealizados": return {"sectionID": name, "sectionName":"Serviços a serem realizados", "inputs": [Field("servicosASeremRealizados")]}
//         case "situacaoInLoco": return {"sectionID": name, "sectionName":"Descrição da situação in loco", "inputs": [Field("situacaoInLoco")]}
        
//         case "unidHabitacionais": return {"sectionID": name, "sectionName":"Unidades habitacionais", "inputs": [Field("unidadesHabitacionais")]}
        
//         case "usoOcupSolo": return {"sectionID": name, "sectionName":"Uso e ocupação do solo", "inputs":
//             [Field("servico"), Field("macrozoneamento"), Field("adeAia"), Field("zoneamentoAeroporto"), Field("zonaProtecao"), Field("zonaRuido")]}

//         case "usoOcupSoloAut": return {"sectionID": "usoOcupSolo", "sectionName":"Uso e ocupação do solo", "inputs":
//             [Field("macrozoneamento"), Field("adeAia"), Field("zoneamentoAeroporto"), Field("zonaProtecao")]}

//         case "usoOcupSoloSimples": return {"sectionID": "usoOcupSolo", "sectionName":"Uso e ocupação do solo", "inputs":
//             [Field("macrozoneamento"), Field("adeAia")]}

//         case "usoOcupSoloCertUsoOcupSolo": return {"sectionID": name, "sectionName":"Uso e ocupação do solo", "inputs":
//             [Field("classificacaoUso"), Field("atividade"), Field("macrozoneamento"), Field("adeAia"),
//             Field("zoneamentoAeroporto"), Field("zonaProtecao"), Field("zonaRuido"), Field("usosIncomodos"),
//             Field("classificacaoViaria"), Field("paisagemNotavel"), Field("equipamentosImpacto"), Field("areaSubJudice"),
//             Field("imovelConstruido"), Field("areaNonEdificantiSistViario"), Field("areaNonEdificantiIntPublico"), Field("patrimonioCultural")
//         ]}
        
//         case "vagas": return {"sectionID": name, "sectionName":"Vagas de estacionamento", "inputs": [Field("vagasVeiculo"), Field("vagasMoto"), Field("vagasBicicleta"), Field("descricaoVagas")]}
//         // case "taxas": return {"sectionID": name, "sectionName":"Taxas", "inputs": [Field("complexidade"), Field("taxaTotal")]}
        
//         // case "taxasTermoDesm": return {"sectionID": name, "sectionName":"Taxas - CTM lei 1.547/1989", "inputs": [Field("taxaTotal"), Field("taxaDemarc"), Field("taxaVist")]}
//         case "taxaTotal": return {"sectionID": "taxas", "sectionName":"Taxas", "inputs": [Field("taxaTotal")]}
//         case "tipoDeUso": return {"sectionID": "tipoUso", "sectionName":"Tipo de uso", "inputs": [Field("tipoUso")]}
//         default: return {}
//     }
// }